interface AdminLoadingStateProps {
  type: 'detail' | 'table'
}

export default function AdminLoadingState({ type }: AdminLoadingStateProps) {
  if (type === 'detail') {
    return (
      <div className="animate-pulse">
        <div className="h-10 bg-gray-300 rounded w-1/3 mb-8"></div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-lg p-6 h-96"></div>
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-lg p-6 h-48"></div>
            <div className="bg-white rounded-lg p-6 h-64"></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="animate-pulse">
      <div className="h-8 bg-gray-300 rounded w-1/4 mb-8"></div>
      <div className="bg-white rounded-lg shadow">
        <div className="p-6 space-y-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="h-16 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    </div>
  )
}
